import * as React from 'react'
import styled from 'styled-components'
import checkIcon from './check-icon.svg'

const Container = styled.div`
  display: block;
  position: relative;
  padding-left: 42px;
  min-height: 30px;
  margin-bottom: 10px;
`

const Input = styled.input`
  position: absolute;
  z-index: -1;
  opacity: 0;
`

const Label = styled.label`
  display: inline-block;
  margin-bottom: 0;
  padding: 3px 0;

  ::before{
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 30px;
    height: 30px;
    /* pointer-events: none; */
    content: "";
    /* user-select: none; */
    border: solid 1px #bab4ce;
    border-radius: 5px;
    background: white;
  }

  ::after{
    position: absolute;
    top: 10px;
    left: 6px;
    display: block;
    width: 18px;
    height: 12px;
    content: "";
    background-repeat: no-repeat;
    background: url(${checkIcon});
  }

  ${Input}:checked~&::before {
    border-color: #FA8D2D;
    background: #FA8D2D;
  }

  /* ${Input}:checked~&::after {
    background-color: #FA8D2D;
  } */
`

interface IProps {
  id: string
  label: string
  [key: string]: any
}

export const Checkbox = ({ id, label, style, form, field, ...rest }: IProps) => (
  <Container style={style}>
    <Input {...field} {...rest} id={id} type="checkbox" />
    <Label htmlFor={id}>{label}</Label>
  </Container>
)



// WEBPACK FOOTER //
// ./src/atoms/Checkbox/index.tsx